<template>
  <div class="flex flex-col lg:flex-row gap-8">
    <aside class="w-full lg:w-72 flex-shrink-0 space-y-6" v-if="!mobile && localContent.data && localContent.data.length > 0">
      <!-- Categorías -->
      <div class="border border-border rounded-lg bg-white overflow-hidden shadow-sm">
        <div v-if="childs.length > 0"
          class="px-4 py-3 bg-surface border-b border-border flex justify-between items-center">
          <p class="font-semibold text-text-main text-sm uppercase tracking-wide">{{ item22 }}</p>
          <x-icons name="filter_list" class="text-text-secondary text-lg cursor-pointer" />

        </div>

        <div class="item-filter-bra p-4">
          <CategoryTreeItem v-for="cat in categoriesTreeData" :key="cat.key" :item="cat"
            :expanded-keys="expandedCategoryKeys" :selected-keys="selectedCategoryKeys" @toggle="handleToggle"
            @select="onSelectCategory" />
        </div>
      </div>

      <!-- Marca -->
      <div class="border border-border rounded-lg bg-white overflow-hidden shadow-sm">
        <div v-if="brands.length > 0"
          class="px-4 py-3 bg-surface border-b border-border flex justify-between items-center">
          <p class="font-semibold text-text-main text-sm uppercase tracking-wide">{{ item19 }}</p>
          <x-icons name="filter_list" class="text-text-secondary text-lg cursor-pointer" />
        </div>
        <div class="flex flex-col p-4 gap-4">
          <BrandFilter :brands="brands" v-model="checkedBrandKeys" :title="item19" :text-show-more="item6"
            :text-show-less="item7" :no-results-text="transPeralbaPro.item1008" search-placeholder="Buscar marca..."
            @change="onSelectBrand" />
        </div>
      </div>

      <!-- Precio -->
      <div class="border border-border rounded-lg bg-white overflow-hidden shadow-sm">
        <div class="px-4 py-3 bg-surface border-b border-border flex justify-between items-center">
          <p class="font-semibold text-text-main text-sm uppercase tracking-wide">{{ transPeralbaPro.item903 }}</p>
          <x-icons name="filter_list" class="text-text-secondary text-lg cursor-pointer" />
        </div>
        <div class="p-4">
          <PriceRange :min="0" :max="sliderMaxValuePrice" :values="values" v-model="rangeValues" />
        </div>
      </div>
    </aside>
    <!-- modal filtros mobile -->

    <!-- TODO 
    <div class="fixed inset-0 z-[1500] flex justify-end" role="dialog" aria-modal="true"
      data-close-func="closeFiltersMobilModal" id="modalContainerFiltersMobil">

      <div id="backdropFiltersMobil" class="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity duration-300"
        onclick="closeFiltersMobilModal()"></div>

      <div id="panelFiltersMobil"
        class="relative w-full max-w-[480px] bg-white shadow-2xl h-full flex flex-col transform transition-transform duration-300 ease-out border-l border-border">

        <div class="flex items-center justify-between p-6 border-b border-border bg-white sticky top-0 z-10">
          <div class="flex items-center gap-3">
            <div class="bg-green-50 text-green-600 rounded-full p-1.5 flex items-center justify-center">
              <x-icons name="check" class="text-[20px] font-bold" /> //todo posar check
            </div>
            <strong class="text-lg font-bold text-text-main tracking-tight" id="addedProductModalLabel">
              {{ transPeralbaPro.item904 }}:
            </strong>
          </div>
          <button type="button" onclick="closeFiltersMobilModal()" 
            class="p-2 rounded-full hover:bg-surface text-text-secondary hover:text-primary transition-colors focus:outline-none">
            <x-icons name="search" class="" />
          </button>
        </div>

        <div class="flex-1 overflow-y-auto p-6 bg-white">

          <div class="border border-border rounded-lg bg-white overflow-hidden shadow-sm">
            <div v-if="childs.length > 0"
              class="px-4 py-3 bg-surface border-b border-border flex justify-between items-center">
              <p class="font-semibold text-text-main text-sm uppercase tracking-wide">{{ item22 }}</p>
              <x-icons name="filter_list" class="text-text-secondary text-lg cursor-pointer" />
            </div>

            <div class="item-filter-bra p-4">
              <CategoryTreeItem v-for="cat in categoriesTreeData" :key="cat.key" :item="cat"
                :expanded-keys="expandedCategoryKeys" :selected-keys="selectedCategoryKeys" @toggle="handleToggle"
                @select="onSelectCategory" />
            </div>
          </div>

          <div class="border border-border rounded-lg bg-white overflow-hidden shadow-sm">
            <div v-if="brands.length > 0"
              class="px-4 py-3 bg-surface border-b border-border flex justify-between items-center">
              <p class="font-semibold text-text-main text-sm uppercase tracking-wide">{{ item19 }}</p>
              <x-icons name="filter_list" class="text-text-secondary text-lg cursor-pointer" />
            </div>
            <div class="flex flex-col p-4 gap-4">
              <BrandFilter :brands="brands" v-model="checkedBrandKeys" :title="item19" :text-show-more="item6"
                :text-show-less="item7" :no-results-text="transPeralbaPro.item1008" search-placeholder="Buscar marca..."
                @change="onSelectBrand" />
            </div>
          </div>

          <div class="border border-border rounded-lg bg-white overflow-hidden shadow-sm">
            <div class="px-4 py-3 bg-surface border-b border-border flex justify-between items-center">
              <p class="font-semibold text-text-main text-sm uppercase tracking-wide">{{ transPeralbaPro.item903 }}</p>
              <x-icons name="filter_list" class="text-text-secondary text-lg cursor-pointer" />
            </div>
            <div class="p-4">
              <PriceRange :min="0" :max="sliderMaxValuePrice" :values="values" v-model="rangeValues" />
            </div>
          </div>

        </div>

        <div class="p-6 border-t border-border bg-surface/30">
          <div class="flex flex-col gap-3">
            <a href="https://peralba.com/cistella/pas-1"
              class="w-full py-3.5 px-4 rounded-lg bg-primary text-white font-bold flex items-center justify-center gap-2 hover:bg-primary-dark">
              {{ transPeralbaPro.item905 }}
              <x-icons name="arrow_forward" class="text-[20px]" /> //todo posar arrow_forward
            </a>
          </div>
        </div>
      </div>
    </div>
    -->

    <div class="flex-grow" v-if="localContent.data && localContent.data.length > 0">
      <page-control :query="query" :item10="item10" :item11="item11" :item12="item12" :item13="item13" :item14="item14"
        :count="localCountProducts" :template="templateVal" :mobile="mobile" :trans-peralba-pro="transPeralbaPro"
        :productsCountToShow="productsCountToShow" :order="order" @onOrderChange="handleOrderChange"
        @onQuantityChange="handleQuantityChange" @onChangeTemplate="handleVisibleTemplate" />

      <div id="grid_productos" class="grid gap-2 md:gap-4" :class="templateVal == '0'
        ? 'grid-cols-1'
        : 'grid-cols-[repeat(auto-fill,minmax(280px,1fr))]'">
        <template v-if="isLoadingResults">
          <div v-for="n in skeletonCount" :key="'skeleton-' + n" class="border border-border rounded-lg p-4 bg-white">
            <div v-if="templateVal == '0'" class="flex items-center gap-4">
              <div class="isk-skeleton rounded flex-shrink-0" style="width: 96px; height: 96px"></div>
              <div class="flex-grow">
                <div class="isk-skeleton rounded mb-2" style="height: 14px; width: 60%"></div>
                <div class="isk-skeleton rounded mb-4" style="height: 14px; width: 40%"></div>
                <div class="isk-skeleton rounded" style="height: 22px; width: 25%"></div>
              </div>
            </div>
            <template v-else>
              <div class="isk-skeleton rounded mb-3" style="aspect-ratio: 1 / 1"></div>
              <div class="isk-skeleton rounded mb-2" style="height: 14px"></div>
              <div class="isk-skeleton rounded mb-4" style="height: 14px; width: 66%"></div>
              <div class="isk-skeleton rounded" style="height: 22px; width: 40%"></div>
            </template>
          </div>
        </template>
        <template v-else>
          <product-item :template="templateVal" :mobile="mobile" :item24="item24" :item25="item25" :item26="item26"
            v-for="product in localContent.data" :product="product" :key="product.id" :user="user" :warehouse="warehouse"
            :trans-peralba-pro="transPeralbaPro" :locale="locale" :can-write-orders="canWriteOrders" />
        </template>
      </div>

      <div class="mt-8 flex justify-center" v-if="localContent && localContent.links">
        <nav class="flex items-center gap-2">
          <button @click.prevent="goToPage(localContent.prev_page_url)" :disabled="!localContent.prev_page_url"
            class="p-2 border border-border rounded hover:bg-surface text-text-secondary disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            <x-icons name="chevron_left" class="block" />
          </button>
          <!-- Vue 3: amb <template v-for> la :key va al <template>, no als fills. -->
          <template v-for="(item, idx) in visibleLinks" :key="idx">
            <span v-if="item.label === '...'" class="text-text-secondary px-2 select-none">
              ...
            </span>
            <button v-else @click.prevent="goToPage(item.url)"
              class="w-10 h-10 flex items-center justify-center rounded font-bold transition-colors border border-border"
              :class="[
                item.active
                  ? 'bg-primary text-white border-primary'
                  : 'hover:bg-surface text-text-main'
              ]">
              {{ item.label }}
            </button>
          </template>
          <button @click.prevent="goToPage(localContent.next_page_url)" :disabled="!localContent.next_page_url"
            class="p-2 border border-border rounded hover:bg-surface text-text-secondary disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            <x-icons name="chevron_right" class="block" />
          </button>
        </nav>
      </div>
    </div>

    <div v-else class="p-12 text-center flex flex-col items-center w-full h-full">
      <div class="w-24 h-24 bg-surface rounded-full flex items-center justify-center mb-6">
        <x-icons name="search_off" class="text-text-secondary text-5xl" />
      </div>
      <h1 class="text-2xl font-bold text-text-main mb-4">
        No hem trobat resultats per a la teva cerca
      </h1>
      <p class="text-text-secondary max-w-lg mb-10 leading-relaxed">
        Prova amb altres paraules clau, revisa els filtres
        aplicats o consulta les nostres categories
        principals per trobar el que busques.
      </p>
    </div>
  </div>
</template>
<script>
// Ya no hay filtros globales (`uppercase`, `currency`, `percentage`): Vue 3 no
// tiene filtros. Los unicos que se usaban de verdad eran los locales de
// ProductItem.vue, que ahora son metodos suyos; el registro por aplicacion que
// hacian los dos entries (./filters.js) desaparecio con la fila 3.9.
import ProductItem from "./components/ProductItem";
import PageControl from "./components/PageControl";
import axios from "axios";
import CategoryTreeItem from './components/CategoryTreeItem.vue';
import BrandFilter from './components/BrandFilter.vue';
import PriceRange from './components/PriceRange.vue';

export default {
  props: [
    "content",
    "user",
    "query",
    "item1",
    "item2",
    "item3",
    "item4",
    "item5",
    "item6",
    "item7",
    "item8",
    "item9",
    "item10",
    "item11",
    "item12",
    "item13",
    "item14",
    "item15",
    "item16",
    "item17",
    "item18",
    "item19",
    "item20",
    "item21",
    "item22",
    "item23",
    "item24",
    "item25",
    "item26",
    "item27",
    "childs",
    "childsCategories",
    "warehouse",
    "maxPrice",
    "minPrice",
    "template",
    "mobile",
    "count_products",
    "transPeralbaPro",
    "locale",
    "canWriteOrders",
    "brandsToShow",
    "filterCategories",
    "filterBrands",
    "filterAttributes",
    "filterOrder",
    "filterPerPage",
    "filterMinPrice",
    "filterMaxPrice",
    "filterQuery",
    "cartUrl",
    "attributesFilters",
    // Busqueda instantanea (beta): en vez de navegar al cambiar filtros/orden/
    // pagina, emite 'search-params' y el padre pide el JSON sin recargar.
    "instant",
    // Busqueda instantanea: true mientras el padre esta cargando los resultados
    // de un cambio de filtros/orden/pagina; las cards se muestran como skeleton.
    "resultsLoading",
  ],

  // La busqueda instantanea escucha este evento cuando `instant` esta activo.
  emits: ["search-params"],

  components: {
    ProductItem,
    PageControl,
    CategoryTreeItem,
    BrandFilter,
    PriceRange,
  },
  data() {
    return {
      lastFetchedIdsSignature: '',
      // En Vue 3 las props son de solo lectura (asignarlas lanza TypeError en
      // modo estricto), y este componente refresca el listado sin recargar
      // (fetchFiltered, fetchBulkVariations). Por eso el contenido que se
      // repinta vive en copias locales, sincronizadas con las props por los
      // watchers de abajo.
      localContent: this.content,
      localCountProducts: this.count_products,
      localBrandsToShow: this.brandsToShow,
      categoriesTreeData: this.childs,
      expandedCategoryKeys: [],
      selectedCategoryKeys: [],
      checkedCategoryKeys: [],
      expandedAttributesKeys: [],
      selectedAttributesKeys: [],
      checkedAttributesKeys: [],
      iconButton: "down",
      inputBrand: "",
      productsCountToShow: 25,
      sliderVal: "",
      templateVal: 1,
      sliderPriceOneValue: 0,
      sliderPriceTwoValue: 0, // 32
      sliderPriceOneValueOld: 0,
      sliderPriceTwoValueOld: 0, // 32
      sliderMaxValuePrice: 0, // 32
      minGapPrice: 0,
      sliderPriceOneText: "0€",
      sliderPriceTwoText: "+9,500€",
      values: [],
      myStylePrice: {
        background: "#D9D9D9",
      },
      selectedBrandKeys: [],
      checkedBrandKeys: [],
      expandedBrandKeys: [],
      filteredByBrand: [],
      filteredByCategory: [],
      order: undefined,
      limit: 10,
      added_product: null,
      selled_products: [],
      isMobile: window.innerWidth <= 768,
      brandsTreeData: [],
      currentPage: this.content?.current_page || 1,
      // Pagina real (no instant): true mientras se cargan via JSON los
      // resultados de un cambio de filtros/orden/pagina (cards en skeleton).
      fetchLoading: false,
    };
  },
  computed: {
    rangeValues: {
      get() {
        return [this.sliderPriceOneValue, this.sliderPriceTwoValue];
      },
      set(newValues) {
        if (Array.isArray(newValues)) {
          this.sliderPriceOneValue = newValues[0];
          this.sliderPriceTwoValue = newValues[1];
        }
      }
    },
    visibleLinks() {
      const rawLinks = this.localContent?.links || [];
      if (rawLinks.length <= 1) return [];

      // Quitamos 'Prev' y 'Next'
      const numberLinks = rawLinks.slice(1, -1);
      const total = numberLinks.length;
      const currentIdx = numberLinks.findIndex(l => l.active);
      const current = currentIdx === -1 ? 0 : currentIdx;

      const maxButtons = this.isMobile ? 4 : 8;
      if (total <= maxButtons) return numberLinks;

      const out = [];
      const delta = this.isMobile ? 1 : 2;

      // Lógica de "ventanas"
      let start = Math.max(current - delta, 1);
      let end = Math.min(current + delta, total - 2);

      // Siempre incluimos la primera página
      out.push(numberLinks[0]);

      // Puntos suspensivos iniciales
      if (start > 1) out.push({ label: '...', url: null });

      // Páginas centrales
      for (let i = start; i <= end; i++) {
        if (numberLinks[i]) out.push(numberLinks[i]);
      }

      // Puntos suspensivos finales
      if (end < total - 2) out.push({ label: '...', url: null });

      // Siempre la última página
      out.push(numberLinks[total - 1]);

      return out;
    },
    brands() {
      return this.localBrandsToShow;
    },
    skeletonCount() {
      // Tantos skeletons como cards visibles, para no mover el layout.
      return (
        (this.localContent &&
          this.localContent.data &&
          this.localContent.data.length) ||
        10
      );
    },
    isLoadingResults() {
      // resultsLoading: lo gestiona el padre en modo instant.
      // fetchLoading: lo gestiona este componente en la pagina real.
      return !!(this.resultsLoading || this.fetchLoading);
    },
    attributesTreeData() {
      return Object.entries(this.attributesFilters).map(
        ([categoryKey, items]) => {
          return {
            title: categoryKey,
            key: categoryKey,
            disabled: false,
            children: Object.entries(items).map(([id, value]) => ({
              title: value,
              key: `${categoryKey}-${id}`,
              disabled: false,
            })),
          };
        }
      );
    },
    params() {
      return {
        q: this.filterQuery ?? "",
        categories: this.checkedCategoryKeys ?? "",
        brands: this.checkedBrandKeys ?? "",
        attributes: this.checkedAttributesKeys ?? "",
        minPrice: this.convertPrice(this.sliderPriceOneValue) ?? "",
        maxPrice: this.convertPrice(this.sliderPriceTwoValue) ?? "",
        sortBy: this.order ?? "relevance",
        perPage: this.productsCountToShow ?? 25,
        page: this.currentPage,
      };
    },
    url() {
      var esc = encodeURIComponent;
      var query = Object.keys(this.params)
        .map((k) => esc(k) + "=" + esc(this.params[k]))
        .join("&");

      return window.location.origin + window.location.pathname + "?" + query;
    },
  },

  watch: {
    content: {
      handler(newValue) {
        this.localContent = newValue;
        if (newValue && newValue.data) {
          this.fetchBulkVariations();
        }
      },
      deep: true,
      immediate: true
    },
    // La busqueda instantanea vuelve a pasar estas props en cada respuesta.
    count_products(newValue) {
      this.localCountProducts = newValue;
    },
    brandsToShow(newValue) {
      this.localBrandsToShow = newValue;
    },
    inputBrand() {
      this.updateBrandsTreeData();
    },
    url(newValue, oldValue) {
      let oldQuery = oldValue.split("?")[1] ?? "";
      oldQuery = oldQuery.split("&perPage")[0];

      const initialQuery = "categories=&brands=&attributes=&minPrice=&maxPrice=&sortBy=relevance";

      if (!oldQuery.includes(initialQuery) && newValue !== oldValue) {
        if (this.instant) {
          this.$emit("search-params", { ...this.params });
        } else {
          // Pagina real (cercador / categoria): en vez de recargar, se pide la
          // misma URL en modo JSON y se refresca el grid con skeletons.
          this.fetchFiltered(newValue);
        }
      }
    }
  },

  created() {
    let categories = this.filterCategories.map((item) => item);
    let brands = this.filterBrands.map((item) => parseInt(item));
    let attributes = this.filterAttributes.map((item) => item);

    this.checkedCategoryKeys = categories;
    this.selectedCategoryKeys = [...categories];
    this.expandedCategoryKeys = [...categories];

    this.checkedAttributesKeys = attributes;
    this.selectedAttributesKeys = [...attributes];
    this.expandedAttributesKeys = [...attributes];

    this.checkedBrandKeys = brands;
    this.selectedBrandKeys = [...brands];
    this.expandedBrandKeys = [...brands];
    this.order = this.filterOrder ?? "relevance";
    this.productsCountToShow = this.filterPerPage ?? 25;
  },
  mounted() {
    this.brands.forEach((b, i) => {
      b.visible = i < 10;
    });

    this.updateBrandsTreeData();
    window.addEventListener("resize", this.onResize);
    this.initializeTemplate();
    this.hideLoadingIndicator();
    this.populateSliderValues();
    this.initializeSliderState();
    this.scrollIfHasParams();

    // Pagina real: si hemos reescrito la URL al filtrar sin recargar, el boton
    // atras/adelante restaura ese estado con una navegacion real. Se ignoran
    // los estados de la busqueda instantanea del header (los gestiona ella).
    this._onPopState = (e) => {
      if (this._hasPushedFilters && !(e.state && e.state.instantSearch)) {
        window.location.reload();
      }
    };
    window.addEventListener("popstate", this._onPopState);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("popstate", this._onPopState);
  },
  methods: {
    // Pagina real (cercador o categoria, sin modo instant): cambio de filtros/
    // orden/pagina sin recargar. Se pide la misma URL con ?json=1 (los
    // controladores devuelven los mismos datos que la vista Blade), se muestra
    // el grid en skeleton mientras tanto y se reescribe la URL del navegador
    // para que siga siendo compartible.
    fetchFiltered(url) {
      if (this._abort) this._abort.abort();
      this._abort = new AbortController();
      const seq = (this._fetchSeq = (this._fetchSeq || 0) + 1);

      this.fetchLoading = true;
      this.scrollToListTop();

      // Una unica entrada nueva en el historial para toda la sesion de
      // filtrado (igual que la busqueda instantanea): atras vuelve a la
      // pagina sin filtros, no pasa por cada combinacion intermedia.
      if (!this._hasPushedFilters) {
        history.pushState({ searcherFilters: true }, "", url);
        this._hasPushedFilters = true;
      } else {
        history.replaceState({ searcherFilters: true }, "", url);
      }

      axios
        .get(url, {
          params: { json: 1 },
          signal: this._abort.signal,
          headers: { Accept: "application/json" },
        })
        .then((r) => {
          if (seq !== this._fetchSeq) return;

          // El termino puede resolver a una redireccion (producto directo /
          // categoria): navegacion real, como hasta ahora.
          if (r.data && r.data.redirect) {
            window.location.href = r.data.redirect;
            return;
          }

          // Pagina sin soporte ?json=1 (p. ej. campanyes, que tambien montan
          // este componente): fallback a la navegacion real de siempre.
          if (!r.data || typeof r.data !== "object" || !r.data.results) {
            window.location.href = url;
            return;
          }

          this.localContent = r.data.results;
          this.localCountProducts = r.data.count_products;
          this.localBrandsToShow = r.data.brandsToShow;
          this.fetchLoading = false;
        })
        .catch((e) => {
          if (axios.isCancel(e)) return;
          if (seq !== this._fetchSeq) return;
          // Fallback: la navegacion real de siempre.
          console.error("searcher: error cargando resultados filtrados", e);
          window.location.href = url;
        });
    },
    scrollToListTop() {
      const element = document.querySelector("#listado_productos");
      if (!element) return;

      const headerHeight = 100;
      const top =
        element.getBoundingClientRect().top + window.scrollY - headerHeight;

      // Solo si el listado ha quedado por encima del viewport (p. ej. al
      // paginar desde abajo); si ya se ve, no movemos al usuario.
      if (window.scrollY > top) {
        window.scrollTo({ top, behavior: "smooth" });
      }
    },
    goToPage(url) {
      if (!url || typeof url !== 'string') return;

      // 1. Extraer el número
      const match = url.match(/page=(\d+)/);
      const nextPage = match ? parseInt(match[1]) : 1;

      // 2. Si es la misma página, no hacemos nada
      if (nextPage === this.currentPage) return;

      // 3. Actualizamos la variable LOCAL
      this.currentPage = nextPage;
    },
    onSelectCategory(item) {
      const isExpanded = this.checkedCategoryKeys.includes(item.key);

      const keysToToggle = this.getAllDescendantKeys(item);

      if (isExpanded) {
        this.checkedCategoryKeys = this.checkedCategoryKeys.filter(
          k => !keysToToggle.includes(k)
        );
      } else {
        this.checkedCategoryKeys = [
          ...new Set([...this.checkedCategoryKeys, ...keysToToggle])
        ];
      }

      // Reflejar la seleccion visual al momento: sin esto solo se ve tras la
      // recarga (created), que en modo instant no ocurre.
      this.selectedCategoryKeys = [...this.checkedCategoryKeys];
    },
    async fetchBulkVariations() {
      if (!this.localContent || !this.localContent.data || this.localContent.data.length === 0) return;

      const currentIds = this.localContent.data.map(p => p.id).sort().join(',');

      if (this.lastFetchedIdsSignature === currentIds) {
        return;
      }

      this.lastFetchedIdsSignature = currentIds;

      const ids = this.localContent.data.map(p => p.id);
      if (ids.length === 0) return;

      const urlIdParam = ids.join(',');

      try {
        const { data } = await axios.get(
          `/${this.locale}/get-variation-products/${urlIdParam}`
        );

        // Normalizar respuesta
        let resultsMap = [];
        if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('requested_id')) {
          resultsMap = data;
        } else {
          resultsMap = [{ requested_id: ids[0], data: data }];
        }

        const newData = this.localContent.data.map(product => {
          const extraInfo = resultsMap.find(r => r.requested_id == product.id)?.data;

          if (extraInfo && extraInfo.variants) {
            // ✅ NUEVA ESTRUCTURA: Solo asignamos product.variants
            return {
              ...product,
              variants: extraInfo.variants  // Ya viene con current, attributes, matrix
            };
          }

          // Si no hay variantes, devolvemos el producto sin cambios
          return product;
        });

        this.localContent = { ...this.localContent, data: newData };

      } catch (e) {
        console.error("Error cargando variaciones masivas:", e);
      }
    },
    updateBrandsTreeData() {
      const filtered = this.brands.filter((b) => {
        const matchesSearch =
          this.inputBrand === "" ||
          b.name.toLowerCase().includes(this.inputBrand.toLowerCase());
        return matchesSearch;
      });

      const visible = filtered.filter((b, index) => {
        const isVisible = b.hasOwnProperty("visible") ? b.visible : index < 10;
        return isVisible;
      });

      this.brandsTreeData = visible.map(this.mapBrandToTreeData);
    },
    paginatedLink(link) {
      var page = 1;
      if (link) {
        page = link.split("page=")[1];
      }
      var params = this.params;
      params.page = page;
      var esc = encodeURIComponent;
      var query = Object.keys(params)
        .map((k) => esc(k) + "=" + esc(params[k]))
        .join("&");

      return window.location.origin + window.location.pathname + "?" + query;
    },
    toggleVisibleBrands() {
      const filteredBrands = this.brands.filter(
        (b) =>
          this.inputBrand === "" ||
          b.name.toLowerCase().includes(this.inputBrand.toLowerCase())
      );

      const hasHiddenBrands = filteredBrands.some((b) => b.visible === false);

      if (hasHiddenBrands) {
        filteredBrands.forEach((b) => {
          b.visible = true;
        });
        this.iconButton = "up";
      } else {
        filteredBrands.forEach((b, index) => {
          b.visible = index < 10;
        });
        this.iconButton = "down";
      }
      this.updateBrandsTreeData();
    },
    handleOrderChange(value) {
      this.order = value;
    },
    handleQuantityChange(value) {
      this.productsCountToShow = value;
    },
    getAllDescendantKeys(item) {
      let keys = [item.key];

      if (item.children && item.children.length > 0) {
        item.children.forEach(child => {
          keys = keys.concat(this.getAllDescendantKeys(child));
        });
      }

      return keys;
    },
    handleToggle(item) {
      const index = this.expandedCategoryKeys.indexOf(item.key);

      if (index > -1) {
        this.expandedCategoryKeys.splice(index, 1);
      } else {
        this.expandedCategoryKeys.push(item.key);
      }

      this.expandedCategoryKeys = [...this.expandedCategoryKeys];
    },
    onExpandBrand(expandedKeys) {
      this.expandedBrandKeys = expandedKeys;
    },
    onSelectBrand(selectedKeys, info) {
      this.selectedBrandKeys = selectedKeys;
    },
    isCategoryDisabled(category) {
      const productsInCategory = this.localContent.data.filter(
        (product) => product.category_code === category.catCode
      );
      return !productsInCategory.some((product) =>
        this.filteredByBrand.includes(product)
      );
    },

    mapBrandToTreeData(brand) {
      const isDisabled =
        this.filteredByCategory.length > 0 &&
        !this.filteredByCategory.some((p) => p.brand_id === brand.id);

      return {
        title: brand.name,
        key: brand.id,
        disabled: isDisabled,
      };
    },
    mapCategoriesToTreeData(category) {
      var childCategories = category.childrens
        .filter((item) => item.show === true)
        .map(this.mapCategoriesToTreeData);
      return {
        title: category.translation.name,
        key: category.codeElement,
        disabled: false,
        children: childCategories,
      };
    },
    initializeTemplate() {
      this.templateVal = this.template;
      if (this.mobile) {
        this.limit = 4;
      }
    },
    hideLoadingIndicator() {
      this.$nextTick(() => {
        const element = document.getElementById("loading");
        if (element) {
          element.classList.add("hidden");
        }
      });
    },
    populateSliderValues() {
      const possibleValues = [
        0,
        5,
        10,
        25,
        50,
        100,
        150,
        200,
        300,
        350,
        400,
        450,
        500,
        550,
        600,
        650,
        700,
        750,
        800,
        850,
        900,
        950,
        1000,
        1050,
        1100,
        1200,
        1500,
        2000,
        3000,
        4000,
        5000,
        6000,
        7000,
        8000,
        9000,
        10000,
        15000,
        20000,
        100000,
      ];

      this.values = possibleValues.filter((value) => value <= this.maxPrice);
      // Encontrar el siguiente valor mayor a maxPrice, si existe
      const nextValue = possibleValues.find((value) => value > this.maxPrice);

      // Si hay un valor siguiente, añadirlo a la lista
      if (nextValue !== undefined) {
        this.values.push(nextValue);
      }
    },
    initializeSliderState() {
      const maxIndex = this.values.length - 1;

      // Inicializar mínimo
      let selectedMinIndex = 0;
      if (this.filterMinPrice && this.filterMinPrice > 0) {
        const minPrice = Math.max(
          ...this.values.filter((num) => num <= this.filterMinPrice)
        );
        selectedMinIndex = this.values.findIndex((num) => num === minPrice);
        if (selectedMinIndex === -1) selectedMinIndex = 0;
      }

      // Inicializar máximo
      let selectedMaxIndex = maxIndex;
      if (this.filterMaxPrice && this.filterMaxPrice < 99999999) {
        const maxPrice = Math.min(
          ...this.values.filter((num) => num >= this.filterMaxPrice)
        );
        selectedMaxIndex = this.values.findIndex((num) => num === maxPrice);
        if (selectedMaxIndex === -1) selectedMaxIndex = maxIndex;
      }

      this.sliderPriceOneValue = selectedMinIndex >= 0 ? selectedMinIndex : 0;
      this.sliderPriceTwoValue = selectedMaxIndex >= 0 ? selectedMaxIndex : maxIndex;
      this.sliderPriceOneValueOld = this.sliderPriceOneValue;
      this.sliderPriceTwoValueOld = this.sliderPriceTwoValue;
      this.sliderMaxValuePrice = maxIndex;

      this.slideOnePrice();
      this.slideTwoPrice();
      this.fillColorPrice();
    },
    onResize() {
      this.isMobile = window.innerWidth <= 767;
    },
    convertPrice(value) {
      let i = parseInt(value);
      return this.values[i];
    },
    printOnePrice() {
      const formatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      // Actualizar el texto del precio
      this.sliderPriceOneText = formatter.format(
        this.convertPrice(this.sliderPriceOneValue)
      );

      // Actualizar el color del slider
      this.fillColorPrice();
    },
    printTwoPrice() {
      const formatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      // Determinar el texto del precio
      const priceValue =
        this.sliderPriceTwoValue === this.sliderMaxValuePrice
          ? `+${formatter.format(this.convertPrice(this.sliderMaxValuePrice))}`
          : formatter.format(this.convertPrice(this.sliderPriceTwoValue));

      this.sliderPriceTwoText = priceValue;

      // Actualizar el color del slider
      this.fillColorPrice();
    },
    slideOnePrice() {
      // Guardar el valor anterior
      this.sliderPriceOneValueOld = this.sliderPriceOneValue;

      // Verificar el espacio mínimo
      if (
        this.sliderPriceTwoValue - this.sliderPriceOneValue <=
        this.minGapPrice
      ) {
        this.sliderPriceOneValue = this.sliderPriceTwoValue - this.minGapPrice;
      }

      // Actualizar el precio mostrado
      this.printOnePrice();
    },
    slideTwoPrice() {
      // Guardar el valor anterior
      this.sliderPriceTwoValueOld = this.sliderPriceTwoValue;

      // Verificar el espacio mínimo
      if (
        this.sliderPriceTwoValue - this.sliderPriceOneValue <=
        this.minGapPrice
      ) {
        this.sliderPriceTwoValue = this.sliderPriceOneValue + this.minGapPrice;
      }

      // Actualizar el precio mostrado
      this.printTwoPrice();
    },
    fillColorPrice() {
      let vm = this;
      let percent1 = (vm.sliderPriceOneValue / vm.sliderMaxValuePrice) * 100;
      let percent2 = (vm.sliderPriceTwoValue / vm.sliderMaxValuePrice) * 100;
      vm.myStylePrice.background =
        "linear-gradient(to right, #DDDDDD " +
        percent1 +
        "% , #A6342F " +
        percent1 +
        "% , #A6342F " +
        percent2 +
        "%, #DDDDDD " +
        percent2 +
        "%)";
    },
    handleVisibleTemplate(template) {
      //canvi modo cards o modo llista
      this.templateVal = template;
    },
    scrollIfHasParams() {
      let url = window.location.href;
      if (url.includes("?")) {
        const element = document.querySelector("#listado_productos");
        const headerHeight = 100;

        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }
    },
  },
};
</script>

<style>
/* Mismo skeleton que InstantSearch.vue: se duplica aqui porque en la pagina
   real (cercador / categoria) el bundle de instant-search puede no cargarse. */
.isk-skeleton {
  background: linear-gradient(90deg, #e9ebee 25%, #f4f5f7 37%, #e9ebee 63%);
  background-size: 400% 100%;
  animation: isk-pulse 1.3s ease infinite;
}

@keyframes isk-pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>